module.exports.SERVER_URL = 'http://localhost:3002'
module.exports.GRAPHQL_URL = 'http://localhost:8080/v1/graphql'
